export default __webpack_public_path__ + "img/083edd6b3ac80f4caacfd0091d828ee2.svg";